import Cookies from "js-cookie";
import { apiHelper } from "../apiHelper/apiHelper";
import {
  updateUserRequest,
  updateUserSuccess,
  updateUserFailure,
} from "../slices/userSlice";

import {
  forgotPasswordFailure,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  getAdminListFailure,
  getAdminListRequest,
  getAdminListSuccess,
  getUserListFailure,
  getUserListRequest,
  getUserListSuccess,
  getUserProfileFailure,
  getUserProfileRequest,
  getUserProfileSuccess,
  loginFailure,
  loginRequest,
  loginSuccess,
  logoutFailure,
  logoutRequest,
  logoutSuccess,
  logoutUser,
  resetPasswordFailure,
  resetPasswordRequest,
  resetPasswordSuccess,
  verifyOTPFailure,
  verifyOTPRequest,
  verifyOTPSuccess,
  signupFailure,
  signupRequest,
  signupSuccess,
  getAdminTasksListRequest,
  getAdminTasksListSuccess,
  getAdminTasksListFailure,
} from "../slices/userSlice";

// ========================== NEW API HANDLER =================

// login
export const handleLoginAction = async (formData, dispatch) => {
  const endPoint = "user/login";
  const method = "POST";
  const state1 = loginRequest;
  const state2 = loginSuccess;
  const state3 = loginFailure;
  const isToast = false;
  const isFile = false;
  const body = formData;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast
  );
};

// logout
export const handleLogoutAction = async (userId, dispatch) => {
  const endPoint = `user/logout/${userId}`;
  const method = "POST";
  const state1 = logoutRequest;
  const state2 = logoutSuccess;
  const state3 = logoutFailure;
  const isToast = false;
  const isFile = false;
  const body = {};
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast
  );
};

// create user
export const handleCreateUser = async (formData, dispatch) => {
  const endPoint = "admin/manager";
  const method = "POST";
  const state1 = signupRequest;
  const state2 = signupSuccess;
  const state3 = signupFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  const body = formData;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};

// forgot password
export const handleForgotPassword = async (formData, dispatch) => {
  const endPoint = "user/adminforgotpassword/";
  const method = "POST";
  const state1 = forgotPasswordRequest;
  const state2 = forgotPasswordSuccess;
  const state3 = forgotPasswordFailure;
  const isToast = true;
  const isFile = false;
  const body = formData;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast
  );
};


// forgot password
export const handleVerifyOTP = async (formData, dispatch) => {
  const endPoint = "otp/verifyforgototp";
  const method = "POST";
  const state1 = verifyOTPRequest;
  const state2 = verifyOTPSuccess;
  const state3 = verifyOTPFailure;
  const isToast = true;
  const isFile = false;
  const body = formData;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast
  );
};

// resetPassword
export const handleResetPassword = async (formData, dispatch) => {
  const endPoint = "users/updatepassword/";
  const method = "PUT";
  const state1 = resetPasswordRequest;
  const state2 = resetPasswordSuccess;
  const state3 = resetPasswordFailure;
  const isToast = true;
  const isFile = false;
  const body = formData;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast
  );
};

// update Password
export const handleUpdatePassword = (formData) => async (dispatch) => {
  const endPoint = "updatePassword/";
  const method = "PUT";
  const state1 = resetPasswordRequest;
  const state2 = resetPasswordSuccess;
  const state3 = resetPasswordFailure;
  const isToast = true;
  const isFile = false;
  const body = formData;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast
  );
};


export const handleGetUserProfile = async (userId, dispatch) => {
  const endPoint = `manager/profile/${userId}`;
  const method = "GET";
  const state1 = getUserProfileRequest;
  const state2 = getUserProfileSuccess;
  const state3 = getUserProfileFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};
// get User List

export const handleGetUserList = async (dispatch) => {
  const endPoint = "users/";
  const method = "GET";
  const state1 = getUserListRequest;
  const state2 = getUserListSuccess;
  const state3 = getUserListFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};

// create Admin
export const handleCreateAdmin = async (formData, dispatch) => {

  const endPoint = "admin/signup";
  const method = "POST";
  const state1 = signupRequest;
  const state2 = signupSuccess;
  const state3 = signupFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  const body = formData;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};

// Get All Admin
export const handleGetAllAdmin = async (dispatch) => {
  const endPoint = "admin/";
  const method = "GET";
  const state1 = getAdminListRequest;
  const state2 = getAdminListSuccess;
  const state3 = getAdminListFailure;
  const isFile = false;
  const isToast = true;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};

// Get All Super Admin Tasks
export const handleGetSuperAdminTasks = async (dispatch) => {
  const endPoint = "farmertask";
  const method = "GET";
  const state1 = getAdminTasksListRequest;
  const state2 = getAdminTasksListSuccess;
  const state3 = getAdminTasksListFailure;
  const isFile = false;

  const isToast = true;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};

export const handleUpdateUser = async (userId, formData, dispatch) => {
  const endPoint = `admin/updateuser/${userId}`; // Dynamic endpoint with userId
  const method = "PUT"; // HTTP method for updating
  const state1 = updateUserRequest; // Define your states (similar to signupRequest)
  const state2 = updateUserSuccess; // Define your success state
  const state3 = updateUserFailure; // Define your failure state
  const isToast = false; // Optional: If you want to show toast messages
  const isFile = false; // Optional: If you're sending files (not required here)
  const isToken = true; // Assuming you want to send an auth token in headers

  const body = formData; // The form data to update the user details

  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};

export const handleUpdateProfile = async (userId, formData, dispatch) => {
  const endPoint = `users/updateprofile/${userId}`; // Dynamic endpoint with userId
  const method = "PUT"; // HTTP method for updating
  const state1 = updateUserRequest; // Define your states (similar to signupRequest)
  const state2 = updateUserSuccess; // Define your success state
  const state3 = updateUserFailure; // Define your failure state
  const isToast = false; // Optional: If you want to show toast messages
  const isFile = false; // Optional: If you're sending files (not required here)
  const isToken = true; // Assuming you want to send an auth token in headers

  const body = formData; // The form data to update the user details

  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};
// change Password in Profile Setting
export const handleChangePassword = (userId, formData) => async (dispatch) => {
  const endPoint = `users/updatewithinapppassword/${userId}`;

  const method = "PUT";
  const state1 = resetPasswordRequest;
  const state2 = resetPasswordSuccess;
  const state3 = resetPasswordFailure;
  const isToast = true;
  const isFile = false;
  const body = formData;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};

// Logout User
export const handleLogoutUser = (dispatch, navigate) => {
  Cookies.remove("auth-token");
  dispatch(logoutUser());
  navigate("/");
};
